import { css } from "@emotion/react";
import Image from "next/image";
import Link from "next/link";
import { parseCookies, setCookie } from "nookies";
import { useEffect, useState } from "react";

import { mediaQueryIsMobile } from "~/lib/client/design";
import useIsSpMode from "~/lib/client/hooks/useIsSpMode";

function setHideQuestVerificationFaqCookie() {
  setCookie(null, "HIDE_QUEST_VERIFICATION_FAQ", "true", {
    maxAge: 60 * 60 * 24 * 365,
    path: "/",
  });
}

function getHideQuestVerificationFaqCookie() {
  return parseCookies().HIDE_QUEST_VERIFICATION_FAQ;
}

function useHideQuestVerificationFaqCookie() {
  const [isHide, setIsHide] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    setIsHide(getHideQuestVerificationFaqCookie() === "true");
  }, []);

  return isHide;
}

/**
 * cookie に HIDE_QUEST_VERIFICATION_FAQ がある場合は表示しない
 *
 */
export const QuestVerificationFaq = () => {
  const isSpMode = !!useIsSpMode();
  const isHide = useHideQuestVerificationFaqCookie();

  if (isHide || isHide === undefined) {
    return null;
  }

  return (
    <div css={rootStyle}>
      <h3>
        クエスト認証に関するQ&A
        <span
          role={"button"}
          css={hideButtonStyle}
          onClick={setHideQuestVerificationFaqCookie}
        >
          [x]
        </span>
      </h3>
      <details>
        <summary>活動がわかる記録とはなんですか？</summary>
        <div css={exampleCaptionContainerStyle}>
          <p>
            例えばアカウントをフォローするクエストの認証ではスクリーンショットを送ってください。
          </p>
          <Image
            src={
              "https://d1stpor4o81wuq.cloudfront.net/images/スクリーンショット 2023-11-16 11.54.46.png"
            }
            alt={"送信するイメージの例"}
            width={isSpMode ? 300 : 492}
            height={isSpMode ? 102 : 168}
          />
        </div>
      </details>
      <details>
        <summary>申請した画像はどうなりますか？</summary>
        <div css={exampleCaptionContainerStyle}>
          <p>
            FUSSYのスタッフが認証のために確認します。
            <br />
            アップロードした画像は公開されませんが、
            <Link href={"/me"} css={myPageLinkStyle}>
              MyPage
            </Link>
            のQuest Memoryにあなたの思い出として残ります。
          </p>
        </div>
      </details>
    </div>
  );
};

const rootStyle = css`
  background: #ffffe8;
  border-radius: 0.25rem;
  padding: 1rem;
  color: #333;

  h3 {
    margin: 0 0 1rem;

    ::before {
      content: "💡";
    }
  }

  details {
    margin-bottom: 1rem;
  }

  ${mediaQueryIsMobile(css`
    font-size: 0.8rem;
  `)}
`;

const exampleCaptionContainerStyle = css`
  width: 100%;
  display: flex;
  flex-flow: column;

  img,
  p {
    margin-left: 1rem;
  }
`;

const myPageLinkStyle = css`
  text-decoration: underline;
`;

const hideButtonStyle = css`
  cursor: pointer;
  font-size: 0.8rem;
  color: #666;
  margin-left: 0.5rem;
`;
